import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { ArrowRightIcon } from 'src/ui/assets/icons/arrow/ArrowRightIcon';
import { ChevronIcon } from 'src/ui/assets/icons/arrow/ChevronIcon';
import { withConfig } from 'src/withConfig';

type SectionHeaderWrapperType = {
    isOpen: boolean;
    variant: DefaultComponentVariantType | null;
}

export const CollapseWrapper = withConfig(theme => styled('div', { label: 'CollapseWrapper' }) <SectionHeaderWrapperType>`
    align-items: center;
    background: ${theme.star.collapse.sport.bgColor};
    color: ${theme.star.collapse.sport.txtColor};
    cursor: pointer;
    display: flex;
    flex-flow: row nowrap;
    gap: 8px;
    height: 36px;
    justify-content: start;
    padding: 8px;
    position: relative;
    border-radius: ${theme.star.collapse.radius};
    &::after {
        border-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none' : `1px solid ${theme.star.collapse.sport.borderColor}`};
        inset: auto 0 0;
        content: '';
        opacity: ${({ isOpen }):string => isOpen ? '0' : '1'};
        position: absolute;
        transition: opacity .2s ease;
        width: 100%;
    }
`);

export const ChevronWrapper = withConfig(theme => styled(ChevronIcon, { label: 'ChevronWrapper' })`
    fill: ${theme.star.collapse.sport.bgColorSecondary};
    flex: 0 0 16px;
    width: 16px;
`);

interface SportIconWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SportIconWrapper = withConfig(theme => styled('div', { label: 'SportIconWrapper' })<SportIconWrapperPropsType>`
    display: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'flex' : 'none'};
    align-items: center;
    align-self: center;
    svg {
        fill: ${theme.star.collapse.sport.txtColor};
        width: 20px;
    }
`);

export const SectionTitle = withConfig(theme => styled('h3', { label: 'SectionTitle' })`
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4286;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    white-space: nowrap;
`);

interface ViewAllWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const ViewAllWrapper = withConfig(theme => styled(Link, { label: 'ViewAllWrapper' })<ViewAllWrapperPropsType>`
    color: ${theme.star.racingNextOff.raceBox.txtColor};
    display: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'flex': 'none'};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    gap: 4px;
    line-height: 1.3334;
    text-decoration: none;
`);

export const ViewAllArrowWrapper = withConfig(theme => styled(ArrowRightIcon, { label: 'ViewAllArrowWrapper' })`
    fill: ${theme.star.casino.casinoSlider.bgColor};
    width: 12px;
`);


